// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.learn_steps__qp3K6 {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: var(--space-5);
  grid-template-columns: minmax(0, 1fr);
  counter-reset: s;
}
.learn_step__IFxRI {
  position: relative;
  padding: var(--space-6);
  background: var(--color-paper);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
}
.learn_num__-7Qd8 {
  display: inline-grid;
  place-items: center;
  width: 2.75rem;
  height: 2.75rem;
  margin-bottom: var(--space-4);
  border-radius: 50%;
  background: var(--color-ink);
  color: var(--kur-gold);
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}
.learn_stepTitle__eLcJF {
  margin: 0 0 var(--space-2);
  font-size: 1.2rem;
  font-weight: 500;
}
.learn_stepText__PYxko {
  margin: 0;
  line-height: 1.55;
  color: var(--color-text-muted);
}
.learn_benefits__Nji-W {
  margin-top: clamp(3rem, 2rem + 3vw, 5rem);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-5);
}
.learn_benefitsTitle__R4IjN {
  margin: 0;
  font-size: var(--text-h3);
  font-weight: 500;
}
.learn_benefitList__AFJ7z {
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 0 var(--space-6);
  grid-template-columns: minmax(0, 1fr);
  border-top: 1px solid var(--color-border);
}
.learn_benefitList__AFJ7z li {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: var(--space-4) 0;
  border-bottom: 1px solid var(--color-border);
}
.learn_benefitList__AFJ7z strong {
  font-weight: 500;
  font-size: 1.1rem;
}
.learn_benefitList__AFJ7z span {
  color: var(--color-text-muted);
}

@media (min-width: 768px) {
  .learn_steps__qp3K6 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .learn_benefitList__AFJ7z {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (min-width: 992px) {
  .learn_steps__qp3K6 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/PATIENTS/SECTIONS/LEARN/learn.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;EACtB,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,qCAAqC;EACrC,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,4CAA4C;AAC9C;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;AACF;AACA;EACE;IACE,gDAAgD;EAClD;AACF","sourcesContent":[".steps {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  gap: var(--space-5);\n  grid-template-columns: minmax(0, 1fr);\n  counter-reset: s;\n}\n.step {\n  position: relative;\n  padding: var(--space-6);\n  background: var(--color-paper);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n}\n.num {\n  display: inline-grid;\n  place-items: center;\n  width: 2.75rem;\n  height: 2.75rem;\n  margin-bottom: var(--space-4);\n  border-radius: 50%;\n  background: var(--color-ink);\n  color: var(--kur-gold);\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n.stepTitle {\n  margin: 0 0 var(--space-2);\n  font-size: 1.2rem;\n  font-weight: 500;\n}\n.stepText {\n  margin: 0;\n  line-height: 1.55;\n  color: var(--color-text-muted);\n}\n.benefits {\n  margin-top: clamp(3rem, 2rem + 3vw, 5rem);\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--space-5);\n}\n.benefitsTitle {\n  margin: 0;\n  font-size: var(--text-h3);\n  font-weight: 500;\n}\n.benefitList {\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  gap: 0 var(--space-6);\n  grid-template-columns: minmax(0, 1fr);\n  border-top: 1px solid var(--color-border);\n}\n.benefitList li {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  padding: var(--space-4) 0;\n  border-bottom: 1px solid var(--color-border);\n}\n.benefitList strong {\n  font-weight: 500;\n  font-size: 1.1rem;\n}\n.benefitList span {\n  color: var(--color-text-muted);\n}\n\n@media (min-width: 768px) {\n  .steps {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .benefitList {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n@media (min-width: 992px) {\n  .steps {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"steps": `learn_steps__qp3K6`,
	"step": `learn_step__IFxRI`,
	"num": `learn_num__-7Qd8`,
	"stepTitle": `learn_stepTitle__eLcJF`,
	"stepText": `learn_stepText__PYxko`,
	"benefits": `learn_benefits__Nji-W`,
	"benefitsTitle": `learn_benefitsTitle__R4IjN`,
	"benefitList": `learn_benefitList__AFJ7z`
};
export default ___CSS_LOADER_EXPORT___;
